import React, { type ReactElement } from 'react';

import { Theme } from '@interfaces/global';
import { LeadDetails } from '@utils/backend-api/users';
import { LeadType } from '@utils/types';

import PaywallBanner from './Banner';
import { Offer } from './OfferOption';
import PaywallFull from './Standard/Full';

export enum PaywallType {
  Full = 'full',
  Banner = 'banner',
}

export interface PaywallProps {
  articleId?: number;
  briefingGuid?: string;
  buttonText?: string;
  isLoggedIn?: boolean;
  isPro?: boolean;
  isTwoOptPaywall?: boolean;
  leadDetails?: LeadDetails;
  leadType?: LeadType;
  offerCode?: string;
  offerLink?: string;
  paywallLeadOffers?: Offer[];
  paywallType?: PaywallType;
  shareGuid?: string;
  skipVerifyNewEmail?: boolean;
  subtitle?: string;
  theme?: Theme;
  title?: string;
  unlockContent?: boolean;
}

export const getPaywallLayout = (type: string) => {
  switch (type) {
    case PaywallType.Full:
      return PaywallFull;
    case PaywallType.Banner:
      return PaywallBanner;
    default:
      return null;
  }
};

const Paywall = (props: PaywallProps): ReactElement => {
  const PaywallLayout = getPaywallLayout(props.paywallType);

  return <PaywallLayout {...props} />;
};

export default Paywall;
